// extracted by mini-css-extract-plugin
export default {"num-catalog__title":"num-catalog_num-catalog__title__STbqC"};